export const challanFaqClicked = {
    event: "faq_scrolled",
    eventCategory: "Challan_homepage",
    eventAction: "faq_scrolled"
};
